export default __webpack_public_path__ + "static/media/lainnya-img-banner.a731ddb9.png";